import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Server, Shield } from 'lucide-react';
import { freeOfferings } from '../mock';

const iconMap = {
  Globe: Globe,
  Server: Server,
  Shield: Shield,
};

const FreeOfferings = () => {
  return (
    <section className="py-20 relative overflow-hidden bg-gradient-to-b from-[#f8fafc] to-white">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="p-8 md:p-14 rounded-3xl glass border border-purple-200 relative overflow-hidden shadow-lg shadow-purple-500/5">
          {/* Ambient Glow */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-purple-200/30 blur-[100px] pointer-events-none" />

          {/* Section Header */}
          <div className="text-center max-w-2xl mx-auto mb-12">
            <span className="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-purple-100 text-purple-700 border border-purple-200 mb-3 inline-block">
              Exclusive Added Value
            </span>
            <h3 className="text-3xl sm:text-4xl font-extrabold font-display text-slate-900">
              Complimentary Services Included
            </h3>
          </div>

          {/* Offerings Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {freeOfferings.map((item, idx) => {
              const IconComp = iconMap[item.icon] || Globe;

              return (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.15 }}
                  className="p-6 rounded-2xl glass-card flex flex-col items-center text-center group"
                >
                  <div className="w-12 h-12 rounded-xl bg-purple-100 text-purple-600 flex items-center justify-center mb-4 group-hover:scale-110 group-hover:bg-purple-600 group-hover:text-white transition-all shadow-sm">
                    <IconComp size={24} />
                  </div>
                  <h4 className="text-xl font-bold font-display text-slate-900 mb-2">
                    {item.title}
                  </h4>
                  <p className="text-slate-600 text-xs leading-relaxed font-normal">
                    {item.description}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeOfferings;
